import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {useVerifiedPermissions} from '../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../config/rbac/actions.ts';

// READ-ONLY (FNP-969): two routes only. There is no `add` route and no edit
// route because there is nothing to add or edit — openTestRun / closeTestRun /
// abandonTestRun are @aws_iam, written by the executor canary.
export const TestRunsLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListTestRuns) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetTestRun) ? (
                        <DetailPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
        </Routes>
    );
};
